import React, { useRef } from "react";
import { Button, Menu } from "@mantine/core";
import { IconFileUpload, IconChevronDown } from "@tabler/icons-react";

export default function UploadVersionSplitButton({
	disabled,
	disabledHoverText,
	fileListChangeHandler,
	uploadAccept,
	firmHasManualVersioningEnabled,
}) {
	const majorInputRef = useRef(null);
	const minorInputRef = useRef(null);

	const makeChangeHandler = (ref, isNewVersion) => (event) => {
		const files = event.target.files;
		if (fileListChangeHandler && files.length) {
			fileListChangeHandler(
				files,
				() => {
					ref.current.value = null;
				},
				isNewVersion
			);
		}
	};

	const accept = uploadAccept || "*";
	const sharedInputProps = {
		disabled,
		accept,
		type: "file",
		style: { display: "none" },
	};

	return (
		<span
			title={disabled ? disabledHoverText : undefined}
			style={{ minWidth: "fit-content" }}
		>
			<input
				ref={majorInputRef}
				{...sharedInputProps}
				onChange={makeChangeHandler(majorInputRef, true)}
				onClick={(e) => {
					e.target.value = null;
				}}
			/>
			{firmHasManualVersioningEnabled ? (
				<>
					<input
						ref={minorInputRef}
						{...sharedInputProps}
						onChange={makeChangeHandler(minorInputRef, false)}
						onClick={(e) => {
							e.target.value = null;
						}}
					/>
					<Menu position="bottom-start">
						<Menu.Target>
							<Button
								variant="default"
								disabled={disabled}
								leftSection={
									<IconFileUpload
										size={16}
										style={{ verticalAlign: "middle" }}
									/>
								}
								rightSection={<IconChevronDown size={14} />}
							>
								Upload...
							</Button>
						</Menu.Target>
						<Menu.Dropdown>
							<Menu.Item
								onClick={() => majorInputRef.current?.click()}
								leftSection={<IconFileUpload size={14} />}
							>
								Upload As New Version
							</Menu.Item>
							<Menu.Item
								onClick={() => minorInputRef.current?.click()}
								leftSection={<IconFileUpload size={14} />}
							>
								Upload As New Save
							</Menu.Item>
						</Menu.Dropdown>
					</Menu>
				</>
			) : (
				<Button
					variant="default"
					disabled={disabled}
					leftSection={
						<IconFileUpload
							size={16}
							style={{ verticalAlign: "middle" }}
						/>
					}
					onClick={() => !disabled && majorInputRef.current?.click()}
				>
					Upload New Version
				</Button>
			)}
		</span>
	);
}
